import React, {
    createContext,
    useContext,
} from 'react';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';

import USER_QUERY from 'app/graphql/network/auth/userQuery.graphql';
import { AuthContext } from 'app/containers/AuthContainer';


export const UserContext = createContext({});


export function UserProvider(props) {
    const { children } = props;

    const authContext = useContext(AuthContext);
    const userQuery = useQuery(USER_QUERY, {
        context: {
            massage: 'app:init:UserProvider',
        },
    });

    const handleClickQuit = () => {
        authContext.onUserQuit();
        window.location.reload();
    };

    const contextValue = {
        userQuery,
        isAuthed: authContext.isAuthed,
        onClickQuit: handleClickQuit,
    };

    return (
        <UserContext.Provider value={contextValue}>
            {userQuery.data && children}
        </UserContext.Provider>
    );
}

UserProvider.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};
